import { createRouter, createWebHistory } from 'vue-router'
import { clearAllAuthStorage, getAccessToken } from '@/lib/auth-storage'
import { consumeAuthCodeFromSearch } from '@/lib/kiosk-boot'
import { clearParkingOsSession, getParkingOsSession } from '@/lib/parking-session'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/LoginView.vue'),
      meta: { public: true, title: '云岗亭登录' },
    },
    {
      path: '/',
      name: 'booth',
      component: () => import('@/views/booth/BoothView.vue'),
      meta: { title: '云岗亭' },
    },
    {
      path: '/booth',
      redirect: (to) => ({ path: '/', query: to.query }),
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: (to) => ({ path: '/', query: to.query }),
    },
  ],
})

router.beforeEach(async (to) => {
  if (to.meta.title) {
    document.title = String(to.meta.title)
  }

  const params = new URLSearchParams(to.fullPath.split('?')[1] || '')
  const authCode = typeof to.query.authCode === 'string' ? to.query.authCode.trim() : ''
  if (authCode) {
    try {
      const result = await consumeAuthCodeFromSearch(`?authCode=${encodeURIComponent(authCode)}`)
      if (!result.ok) {
        return { name: 'login', query: result.message ? { reason: result.message } : {} }
      }
      return { path: '/', replace: true }
    } catch {
      return { name: 'login', query: { reason: '授权码兑换失败，请从车场后台重新进入' } }
    }
  }

  // Park 工作台旧跳转会带 a/b（车场 token），岗亭 /kiosk 接口不接受。
  if (params.get('a')?.trim() && params.get('b')?.trim()) {
    clearParkingOsSession()
    clearAllAuthStorage()
    if (to.meta.public) return true
    return { name: 'login', query: { reason: '请从车场后台重新进入云岗亭' }, replace: true }
  }

  if (to.meta.public) return true

  if (getParkingOsSession() || getAccessToken()) return true
  return { name: 'login', query: to.query }
})

export default router
